<template>
  <div class="tabla">
    <!-- Prueba tabla -->
    <div class="panel panel-flat">
      <div class="panel-body">
        <JqxLoader
          ref="jqxLoader"
          :imagePosition="'top'"
          :width="100"
          :height="60"
          :theme="'custom'"
          :text="'Cargando...'"
        ></JqxLoader>
        <JqxGrid
          ref="tablaStocks"
          :width="width"
          :height="heightTabla"
          :source="dataAdapter"
          :columns="columns"
          :filterable="true"
          :autoshowfiltericon="true"
          :sorting="true"
          :sortable="true"
          :groupable="true"
          :localization="localization"
          :showfilterrow="true"
          :selectionmode="'multiplecellsadvanced'"
          :scrollmode="'deferred'"
          :deferreddatafields="['movimiento','almacen','tipo','seccion','familia','subfamilia','temporada','marca']"
          :altrows="true"
          :autosavestate="true"
          :autoshowloadelement="false"
          :closeablegroups="false"
          :showgroupaggregates="true"
          :showstatusbar="true"
          :showaggregates="true"
          :statusbarheight="25"
          :columnsresize="true"
          :theme="'custom'"
        ></JqxGrid>
        <div style="margin-top: 20px">
          <div style="margin-left: 10px; float: left">
            <JqxButton :theme="'custom'" @click="imprimir()">Imprimir</JqxButton>
          </div>
          <div style="margin-left: 10px; float: left">
            <JqxButton :theme="'custom'" @click="exportarXls()">Exportar .xls</JqxButton>
          </div>
          <div style="margin-left: 10px; float: left">
            <JqxButton :theme="'custom'" @click="exportarPdf()">Exportar .pdf</JqxButton>
          </div>
        </div>
      </div>
    </div>
    <!-- /Prueba tabla -->
  </div>
</template>
<script>
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
import JqxButton from "jqwidgets-scripts/jqwidgets-vue/vue_jqxbuttons.vue";
import JqxLoader from "jqwidgets-scripts/jqwidgets-vue/vue_jqxloader.vue";
import { Util } from "@/api/Util";

import { BiApiService } from "@/api/BiApiService";
const util = new Util();

const biApiService = new BiApiService();

export default {
  components: {
    JqxGrid,
    JqxButton,
    JqxLoader
  },
  data() {
    return {
      bip_item_id: Number(this.$route.query.tienda),
      localization: this.getLocalization(),
      lang: this.$store.getters.lang,
      // eslint-disable-next-line
      dataAdapter: new jqx.dataAdapter(this.source),
      width: "100%",
      selectionmode: "multiplerowsextended",
      showaggregates: true,
      columns: [
        {
          text: "Movimiento",
          dataField: "movimiento",
          width: "6%",
          filtertype: "checkedlist"
        },
        {
          text: "Almacen",
          dataField: "almacen",
          width: "8%",
          filtertype: "checkedlist"
        },
        {
          text: "Tipo",
          dataField: "tipo",
          width: "6%",
          filtertype: "checkedlist"
        },
        {
          text: "Seccion",
          dataField: "seccion",
          width: "5%",
          filtertype: "checkedlist"
        },
        {
          text: "Familia",
          dataField: "familia",
          width: "5%",
          filtertype: "checkedlist"
        },
        {
          text: "Subfamilia",
          dataField: "subfamilia",
          width: "5%",
          filtertype: "checkedlist"
        },
        // { text: "Modelo", dataField: "modelo", width: 150, filtertype: 'checkedlist' },
        // { text: "Color", dataField: "color", width: 150, filtertype: 'checkedlist' },
        // { text: "Localizador", dataField: "localizador", width: 90 },
        {
          text: "Temporada",
          dataField: "temporada",
          width: "7%",
          filtertype: "checkedlist"
        },
        {
          text: "Marca",
          dataField: "marca",
          width: "5%",
          filtertype: "checkedlist"
        },
        // TOTALES
        {
          text: "Total",
          dataField: "total",
          width: "4%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>Total</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "Total SL",
          dataField: "total_sl",
          width: "4%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>Total SL</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "R",
          dataField: "r",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>R</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "U",
          dataField: "u",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>U</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL1",
          dataField: "sl1",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL1</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL2",
          dataField: "sl2",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL2</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL3",
          dataField: "sl3",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL3</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL4",
          dataField: "sl4",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL4</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL5",
          dataField: "sl5",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL5</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL6",
          dataField: "sl6",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL6</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL7",
          dataField: "sl7",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL7</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL8",
          dataField: "sl8",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL8</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL9",
          dataField: "sl9",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL9</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL10",
          dataField: "sl10",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL10</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL11",
          dataField: "sl11",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL11</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL12",
          dataField: "sl12",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL12</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        },
        {
          text: "SL13",
          dataField: "sl13",
          width: "3%",
          cellsalign: "right",
          aggregates: [
            {
              "<b>SL13</b>": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ]
        }
        // /TOTALES
      ],
      id: "row",
      tableData: [],
      window: {
        width: 0,
        height: 0
      }
    };
  },
  beforeCreate: function() {
    this.source = {
      localdata: [],
      autoloadstate: false,
      datafields: [
        { name: "movimiento", type: "string" },
        { name: "row", type: "number" },
        { name: "almacen", type: "string" },
        { name: "tipo", type: "string" },
        { name: "seccion", type: "string" },
        { name: "familia", type: "string" },
        { name: "subfamilia", type: "string" },
        // { name: "modelo", type: "string" },
        // { name: "color", type: "string" },
        // { name: "localizador", type: "number" },
        { name: "temporada", type: "string" },
        { name: "marca", type: "string" },
        // TOTALES
        { name: "total", type: "number" },
        { name: "total_sl", type: "number" },
        { name: "r", type: "number" },
        { name: "u", type: "number" },
        { name: "sl1", type: "number" },
        { name: "sl2", type: "number" },
        { name: "sl3", type: "number" },
        { name: "sl4", type: "number" },
        { name: "sl5", type: "number" },
        { name: "sl6", type: "number" },
        { name: "sl7", type: "number" },
        { name: "sl8", type: "number" },
        { name: "sl9", type: "number" },
        { name: "sl10", type: "number" },
        { name: "sl11", type: "number" },
        { name: "sl12", type: "number" },
        { name: "sl13", type: "number" }
        // /TOTALES
      ],
      datatype: "array"
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  mounted() {
    // this.generatedata(50);
    this.getAllStockLibre();
    this.$refs.jqxLoader.open();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    generatedata(num) {
      let data = [];
      let count = 0;
      for (let i = 0; i <= num; i++) {
        if (count < 5) {
          count++;
        } else {
          count = 0;
        }
        const dataItem = {
          firstname: `Nombre ${count}`,
          lastname: `Apellido ${i}`,
          productname: `Producto ${i}`,
          quantity: Math.floor(Math.random() * (10 - 1 + 1)) + 1,
          price: Math.floor(Math.random() * (200 - 1 + 1)) + 1,
          total: Math.floor(Math.random() * (50 - 1 + 1)) + 1
        };
        data.push(dataItem);
      }
      return data;
    },
    imprimir: function() {
      let gridContent = this.$refs.tablaStocks.exportdata("html");
      let newWindow = window.open("", "", "width=800, height=500"),
        document = newWindow.document.open(),
        pageContent =
          "<!DOCTYPE html>\n" +
          "<html>\n" +
          "<head>\n" +
          '<meta charset="utf-8" />\n' +
          "<title>jQWidgets Grid</title>\n" +
          "</head>\n" +
          "<body>\n" +
          gridContent +
          "\n</body>\n</html>";
      document.write(pageContent);
      document.close();
      newWindow.print();
    },
    exportarXls: function() {
      this.$refs.tablaStocks.exportdata("xls", "jqxGrid");
    },
    exportarPdf: function() {
      this.$refs.tablaStocks.exportdata("pdf", "jqxGrid");
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getAllStockLibre() {
      biApiService
        .getAllStockLibre()
        .then(data => {
          this.source.localdata = data;
          // passing `cells` to the `updatebounddata` method will refresh only the cells values when the new rows count is equal to the previous rows count.
          this.$refs.tablaStocks.updatebounddata();
          this.$refs.tablaStocks.addgroup("movimiento");
          this.$refs.jqxLoader.close();
          util.mostrarEnConsola(
            "TablaTodos - getAllStockLibre",
            data.length,
            "OK"
          );
        })
        .catch(error => {
          this.$refs.jqxLoader.close();
          util.mostrarEnConsola(
            "TablaTodos - getAllStockLibre",
            error,
            "ERROR"
          );
        });
    },
    refreshBtnOnClick: function() {
      this.getAllStockLibre();
    },
    getLocalization() {
      let traduccion = {
        // separator of parts of a date (e.g. '/' in 11/05/1955)
        "/": "/",
        // separator of parts of a time (e.g. ':' in 05:44 PM)
        ":": ":",
        // the first day of the week (0 = Sunday, 1 = Monday, etc)
        firstDay: 0,
        days: {
          // full day names
          names: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ],
          // abbreviated day names
          namesAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          // shortest day names
          namesShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
        },
        months: {
          // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
          names: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
            ""
          ],
          // abbreviated month names
          namesAbbr: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
            ""
          ]
        },
        // AM and PM designators in one of these forms:
        // The usual view, and the upper and lower case versions
        //      [standard,lowercase,uppercase]
        // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
        //      null
        AM: ["AM", "am", "AM"],
        PM: ["PM", "pm", "PM"],
        eras: [
          // eras in reverse chronological order.
          // name: the name of the era in this culture (e.g. A.D., C.E.)
          // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
          // offset: offset in years from gregorian calendar
          { name: "A.D.", start: null, offset: 0 }
        ],
        twoDigitYearMax: 2029,
        patterns: {
          // short date pattern
          d: "M/d/yyyy",
          // long date pattern
          D: "dddd, MMMM dd, yyyy",
          // short time pattern
          t: "h:mm tt",
          // long time pattern
          T: "h:mm:ss tt",
          // long date, short time pattern
          f: "dddd, MMMM dd, yyyy h:mm tt",
          // long date, long time pattern
          F: "dddd, MMMM dd, yyyy h:mm:ss tt",
          // month/day pattern
          M: "MMMM dd",
          // month/year pattern
          Y: "yyyy MMMM",
          // S is a sortable format that does not vary by culture
          S:
            "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss"
        },
        percentsymbol: "%",
        currencysymbol: " €",
        currencysymbolposition: "after",
        decimalseparator: ",",
        thousandsseparator: ".",
        pagergotopagestring: "Ir a la página:",
        pagershowrowsstring: "Nº de filas:",
        pagerrangestring: " de ",
        pagerpreviousbuttonstring: "Anterior",
        pagernextbuttonstring: "Siguiente",
        groupsheaderstring:
          "Arrastra el nombre de una columna aquí para agrupar los datos por dicha columna",
        sortascendingstring: "Ordenar asc.",
        sortdescendingstring: "Ordenar desc.",
        sortremovestring: "Quitar ordenación",
        groupbystring: "Agrupar por esta columna",
        groupremovestring: "Quitar agrupación",
        filterclearstring: "Limpiar",
        filterstring: "Filtrar",
        filtershowrowstring: "Mostrar filas que:",
        filtershowrowdatestring: "Show rows where date:",
        filterorconditionstring: "O",
        filterandconditionstring: "Y",
        filterselectallstring: "(Seleccionar todo)",
        filterchoosestring: "Por favor, elija:",
        filterstringcomparisonoperators: [
          "vacío",
          "no vacío",
          "contiene",
          "contiene(coincidir mayús.)",
          "no contiene",
          "no contiene(coincidir mayús.)",
          "comienza por",
          "comienza por(coincidir mayús.)",
          "termina en",
          "termina en(coincidir mayús.)",
          "igual a",
          "igual a(coincidir mayús.)",
          "nulo",
          "no nulo"
        ],
        filternumericcomparisonoperators: [
          "igual",
          "distinto",
          "menor que",
          "menor o igual que",
          "mayor que",
          "mayor o igual que",
          "nulo",
          "no nulo"
        ],
        filterdatecomparisonoperators: [
          "igual",
          "distinto",
          "menor que",
          "menor o igual que",
          "mayor que",
          "mayor o igual que",
          "nulo",
          "no nulo"
        ],
        filterbooleancomparisonoperators: ["igual", "distinto"],
        validationstring: "El valor introducido no es válido",
        emptydatastring: "No hay resultados",
        filterselectstring: "Seleccione filtro",
        loadtext: "Cargando...",
        clearstring: "Limpiar",
        todaystring: "Hoy"
      };
      return traduccion;
    }
  },
  computed: {
    heightTabla: function() {
      let heightTabla = 300;
      let alturaResto = 220;

      if (this.window.height < heightTabla + alturaResto) {
        return heightTabla;
      } else {
        return this.window.height - alturaResto;
      }
    }
  }
};
</script>

